import React, { Component } from 'react'
import { Steps, Form, Row, Col, Button } from 'antd';
import { generateFormFields } from 'utils/formUtils';
import _ from "lodash"

export default class WizardForm extends Component {
    static defaultProps = {
        onChange: _.noop,
        formRef: _.noop,
        onNext: _.noop,
        onPrev: _.noop,
        // onCancel: () => window.history.back(),
        validator: () => [],
        validateOnBackwardStep: true,
        submitButtonText: "Submit",
    }
    static getDerivedStateFromProps(props, state){
        const { initialValues } = props;
        const { data } = state;
        return {
            data: {
                ...initialValues,
                ...data
            }
        }
    }
    constructor(props){
        super(props);
        
        this.state = {
            currentStep: 0,
            data: {},
            fieldErrors: [],
            loading: false,
            visited: {
                0: true
            }
        }

        _.bindAll(
            this,
            "onNext",
            "onPrev",
            "onSubmit",
            "onFinish",
            "onChange",
            "goToStep",
            "skipAndSave",
            "onCancel",
            "onFinishFailed",
            "showLoadingForValidation"
        )
    }
    // componentDidUpdate(prevProps){
    //     if(prevProps.step !== this.props.step && typeof prevProps.step === "number"){
    //         this.setState({})
    //     }
    // }
    async onNext(event){
        const { pages } = this.props
        const { data, currentStep, visited } = this.state
        this.setState({
            loadingNext: true
        });

        // if event, then came via click so need to validate
        // else via form sumbit and no need to validate
        if(event){
            try {
                await this.form.validateFields();;
            } catch (e){
                this.setState({
                    loadingNext: false
                });
                return;
            }
        }
        const values = await this.form.getFieldsValue();
        const currentPage = pages[currentStep];
        const onNext = currentPage.onNext || _.noop;
        try {
            const newData = _.assign({}, data, values);
            await onNext(newData)
            this.props.onNext(currentStep);
            this.setState({
                data: newData,
                currentStep: currentStep + 1,
                visited: {
                    ...visited,
                    [currentStep + 1]: true
                },
                loading: false,
                loadingNext: false
            });
        } catch(e){
            // unhandled catch block
        }
    }
    async onSubmit(event){
        const { data } = this.state
        this.setState({
            loading: true
        });
        // if event, then came via click so need to validate
        // else via form sumbit and no need to validate
        if(event){
            try {
                await this.form.validateFields();
            } catch (e){
                this.setState({
                    loading: false
                });
                return;
            }
        }
        const values = await this.form.getFieldsValue();
        const newData = _.assign({}, data, values);
        this.setState({
            data: newData
        }, this.submitData);
    }
    onCancel(){
        this.props.onCancel();
    }
    async onPrev(){
        try {
            this.props.validateOnBackwardStep && await this.form.validateFields();
        } catch (e){
            this.setState({
                loadingNext: false
            });
            return;
        }
        this.props.onPrev(this.state.currentStep);
        this.setState(({currentStep}) => ({
            currentStep: currentStep - 1
        }));
    }
    async goToStep(e){
        const values = this.form.getFieldsValue();
        const { data, currentStep } = this.state;
        const newData = _.assign({}, data, values);
        this.setState({
            data: newData
        });
        let index;
        try {
            index = e.currentTarget.dataset.index ?? e.currentTarget.parentElement.dataset.index;
        } catch (e) {
            console.log("error jumping to wizard step", e);
        }
        if((this.props.validateOnBackwardStep && currentStep > +index) || currentStep < +index) {
            await this.form.validateFields();
        }
        

        if(!_.isUndefined(index)){
            this.setState({
                currentStep: +index
            })
        }
    }
    async submitData(){
        const {onSuccess = _.noop, api = _.noop, beforeAPI = (d) => d, pages} = this.props;
        const {data: dataFromState} = this.state;
         _.forEach(dataFromState,(value,key)=> {
            if(typeof value === "string") dataFromState[key] = value.trim();
        });
        let data = _.cloneDeep(dataFromState);
        let fieldErrors = [];
        let state = {};
        this.setState({
            loading: true
        });
        try {
            console.log("Data before change", _.cloneDeep(data));
            data = beforeAPI(data);
            console.log("Data after change", _.cloneDeep(data));
            const _data = await api(data);
            onSuccess(_data);
        } catch (e) {
            console.log(e);
            fieldErrors = this.props.validator(e) || [];
            const errors = _.get(e, "response.data.errors");
            if(_.isArray(errors)){
                const fields = errors || [];
                const formFields = fields.map(f => {
                    return {
                        name: f.field,
                        errors: [f.defaultMessage]
                    }
                });
                fieldErrors = [...fieldErrors, ...formFields];
            }
            if(!_.isEmpty(fieldErrors)){
                const name = fieldErrors[0].name;
                let pageNum = 0;
                pages.every(({fields}, i) => {
                    const field = _.find(fields, {name});
                    if(field){
                        pageNum = i;
                        return false;
                    }
                    return true;
                });
                state = {
                    currentStep: pageNum,
                };
            }
        } finally {
            this.setState({
                ...state,
                loading: false,
                loadingNext: false
            }, () => this.form.setFields(fieldErrors));
        }
    }
    onChange(values, allValues){
        // TODO clear validation errors from backend, after fields are changed
        
        (this.props?.onChange || _.noop)(values, allValues);
    }
    onFinish(){
        const { isEdit, pages } = this.props;
        const { currentStep } = this.state;
        if(isEdit){
            return this.skipAndSave();
        }
        if(currentStep === pages.length - 1){
            this.onSubmit();
        } else {
            this.onNext();
        }
    }
    async skipAndSave(){
        this.setState({
            loading: true
        });
        try {
            await this.form.validateFields();
        } catch (e) {
            this.setState({
                loading: false
            });
            return;
        }
        const values = this.form.getFieldsValue();
        const {data} = this.state;
        const newData = _.assign({}, data, values);
        this.setState({
            data: newData
        }, this.onSubmit);
    }
    showLoadingForValidation(){
        const { isEdit } = this.props;
        this.setState({
            [isEdit ? "loading" : "loadingNext"]: true
        });
    }
    onFinishFailed(e){
        console.log(e);
        this.setState({
            loading: false,
            loadingNext: false
        });
    }
    renderForm(){
        const { currentStep, data, fieldErrors, loading, loadingNext } = this.state;
        const { pages, formLayout, isEdit, disableNextConditions, showSkipSaveBtnFromStep } = this.props;
        const shouldDisableNext = disableNextConditions?.find(item => item.index === currentStep)?.condition
        const currentPage = pages[currentStep];
        const Component = currentPage?.component;
        const showComponentBeforeField = _.isBoolean(currentPage?.showComponentBeforeField) ? currentPage.showComponentBeforeField: true;
        const layout = currentPage?.formLayout || formLayout;
        const showSkipSaveBtn = isEdit || (_.isNumber(showSkipSaveBtnFromStep) && currentStep >= showSkipSaveBtnFromStep)
        const form = (
            <>
                <Form
                    layout={layout}
                    labelCol={layout === 'vertical' ? { span: 24 } : {}}
                    wrapperCol={layout === 'vertical' ? { span: 24 }: {}}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                    onValuesChange={this.onChange}
                    initialValues={data}
                    fields={fieldErrors}
                    ref={form => {this.form = form; this.props.formRef(form);}}
                    className={"wizard-form"}
                    onSubmitCapture={this.showLoadingForValidation}
                >
                    {(Component && showComponentBeforeField) ? <Component /> : null}
                    {generateFormFields(currentPage.fields, 24)}
                    {(Component && !showComponentBeforeField) ? <Component /> : null}
                    <Form.Item noStyle>
                        <Row>
                            <Col span={24}>
                                <Button disabled={loading || loadingNext} className="pull-left" onClick={this.onCancel}>Cancel</Button>
                                
                                {/* Hidden submit button just to capture submit */}
                                <Button style={{display: "none"}} htmlType="sumbit" />
                                {/*  */}

                                {
                                    currentStep === pages.length - 1
                                        ?
                                        <Button loading={loading} onClick={this.onSubmit} className="pull-right " type="primary">{this.props.submitButtonText}</Button>
                                        :
                                        <>
                                            {
                                                showSkipSaveBtn 
                                                && 
                                                <Button loading={loading} disabled={loadingNext} className="pull-right m-l-xs" type={"primary"} onClick={this.skipAndSave}>Skip & Save</Button>
                                            }
                                            <Button loading={loadingNext || this.props.loadingNext} disabled={shouldDisableNext || loading} className="pull-right" type={showSkipSaveBtn ? "default" : "primary"} onClick={this.onNext}>Next</Button>
                                        </>
                                }
                                {
                                    currentStep !== 0
                                    &&
                                    <Button disabled={loading} className="pull-right m-r-xs" onClick={this.onPrev}>Previous</Button>
                                }
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
            </>
        )
        return form;
    }
    render() {
        console.warn("`WizardForm` form is depricated, use `WizardFormv2`");
        const {currentStep, visited} = this.state;
        const {pages = [], stepsDirection = "vertical"} = this.props;
        // const values = this.state.data;
        const form = this.renderForm();
        return (
            <>
                <Steps current={currentStep} size="small" direction={stepsDirection} labelPlacement="vertical" >
                    {
                        pages.map(({title, icon}, i) => {
                            const _props = {};
                            if(visited[i] && currentStep !== i){
                                _props.onClick = this.goToStep;
                                _props.className = "clickable";
                            }
                            return (
                                <Steps.Step
                                    data-index={i}
                                    {..._props}
                                    key={title} 
                                    icon={icon} 
                                    title={title} 
                                    description={i === currentStep && stepsDirection === 'vertical' ? form : null} 
                                />
                            )
                        })
                    }
                </Steps>
                { stepsDirection === 'horizontal' ? form : null}
            </>
        )
    }
}
